import './App.scss'

import React from 'react';
import Categories from './components/Categories/Categories';
import ProviderContext from './context/MapProviderContext';
import { QueryClient, QueryClientProvider, useQuery } from 'react-query';
import { fetchProvider } from './lib/getProvider';
import Map from './components/Map/Map';
import LocationInput from './components/Categories/LocationInput';

// Query Providers from API
const queryClient = new QueryClient()
export const useProvider = () => useQuery('providerData', fetchProvider)

const App = ({ Component, pageProps }) => {
  return (
    <>
      <QueryClientProvider client={queryClient}>
        <ProviderContext>
          <div className='flex flex-col-reverse my-[100px] relative'>
            <Map />
            <div className='w-full lg:w-[28rem] relative lg:absolute lg:top-12 lg:left-16 z-[999]'>
              <div className='lg:w-12/12 mx-auto lg:rounded-3xl px-6 py-4 pt-8 bg-white shadow-2xl'>
                <div className='mb-4'>
                  <LocationInput />
                  <div className="mt-6">
                    <Categories />
                  </div>
                </div>
              </div>
            </div>

            <div className="m-4 absolute bottom-0 right-0 z-[9999999] py-4 px-6 bg-brand-primary-500 text-white font-bold rounded-md w-fit text-[0.75rem]">
              {
                (window.innerWidth < 768)
                  ? <span>Zoom: Zwei Finger</span>
                  : <span>Zoom: Strg + Mausrad</span>
              }
            </div>

          </div>
        </ProviderContext>
      </QueryClientProvider>
    </>
  )
};

export default App
